<script>
    import ComboSelect from '../../ComboSelect/ComboSelect.svelte';
    import DataTable from '../../DataGrid/DataTable.svelte';
    import { draftElementDetails, elementInstance } from '../../Workspaces/workspacesStore.js';
    import HazardControlItem from '../../BranchHazard/HazardControlItem.svelte';

    export let data = '';
    export let label = '';
    export let options = [];
    export let onChange = () => {};
    export let row = null;
    export let key = '';
    export let schema = {}
    export let id = '';
    export let searchable = true;
    export let selected = null;
    export let cascadedField = '';
    export let cascadedBy = '';

    let cascadedOptions = [];
    $: if (cascadedField && options.length && row) {
        const filtered = options.filter(o => o.id === row[cascadedBy]);
        if(filtered.length){
            cascadedOptions = filtered[0][cascadedField];
        }
    }

    function handleColumnChange(event) {
        onChange(event, row, selected);
    }

</script>

<!-- {#if row.invalid_hazard_control}
    {#if cascadedBy}
        <HazardControlItem data={row.global_control} />
    {:else}
        <HazardControlItem data={row.global_hazard} invalidhazard={true} />
    {/if}
{:else} -->
    <ComboSelect
        {id}
        {label}
        {key}
        options={cascadedField ? cascadedOptions : options}
        bind:value={data}
        bind:selected={selected}
        on:changed={handleColumnChange}
        {searchable}
        bind:isValid={row.fieldValidations[key].isValid}
        bind:errors={row.fieldValidations[key].errors}
        {schema} />
<!-- {/if} -->
